"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseToast_1 = require("./BaseToast");
var removeNotification_1 = require("../actions/removeNotification");
var updateNotificationIgnore_1 = require("../actions/updateNotificationIgnore");
var notificationHandler_1 = require("../utils/notificationHandler");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./NotificationToast.scss');
var classNames = require('classnames/bind');
var SkypeToast = /** @class */ (function (_super) {
    tslib_1.__extends(SkypeToast, _super);
    function SkypeToast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCancelClick = function (e) {
            e.stopPropagation();
            updateNotificationIgnore_1.default(_this.props.notification, true);
            notificationHandler_1.handleNotification(_this.props.notification);
            _this.onNotificationRemoved();
        };
        _this.onNotificationRemoved = function () {
            if (_this.timer) {
                clearTimeout(_this.timer);
                _this.timer = null;
            }
        };
        return _this;
    }
    SkypeToast.prototype.render = function () {
        var _a = this.props
            .notification, title = _a.title, description = _a.description, actionLink = _a.actionLink, cancelLink = _a.cancelLink;
        // UX is still being decided
        return (React.createElement("div", { className: styles.toast, onClick: this.onActionClick },
            React.createElement("div", { className: styles.iconContainer }, this.renderImage()),
            React.createElement("div", { className: styles.toastInfo },
                React.createElement("div", { className: classNames(styles.title, styles.ellipsisOverflow) }, title),
                React.createElement("div", { className: classNames(styles.description, styles.ellipsisOverflow) }, description),
                React.createElement("div", { className: styles.linksContainer },
                    React.createElement("div", null, actionLink),
                    cancelLink && (React.createElement("div", { className: styles.closeLink, onClick: this.onCancelClick }, cancelLink))))));
    };
    SkypeToast.prototype.componentDidMount = function () {
        var _this = this;
        var displayTime = this.props.notification.displayTime;
        if (displayTime) {
            this.timer = setTimeout(function () {
                removeNotification_1.default(_this.props.notification);
                _this.timer = null;
            }, displayTime);
        }
    };
    SkypeToast.prototype.renderImage = function () {
        return (React.createElement("span", null,
            React.createElement("img", { className: styles.imageCircle, src: this.props.notification.image })));
    };
    SkypeToast = tslib_1.__decorate([
        mobx_react_1.observer
    ], SkypeToast);
    return SkypeToast;
}(BaseToast_1.default));
exports.default = SkypeToast;
//# sourceMappingURL=SkypeToast.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/components/SkypeToast.js
// module id = 1616
// module chunks = 3 14 105 106 107